import React, { FC } from "react";
import { styled, keyframes } from "@mui/system";
import { COLORS, SIZES } from "../../common/consts";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerStyled = styled("div")`
  width: ${SIZES.spinnerSize};
  height: ${SIZES.spinnerSize};
  border-radius: 50%;
  border: 2px solid var(--color-spinnerColor, ${COLORS.spinnerColor});
  border-right-color: transparent;
  border-bottom-color: transparent;
  animation: ${spin} 1s linear infinite;
`;

const Spinner: FC = () => {
  return <SpinnerStyled />;
};

export default Spinner;
